import { getTokenDeliveryMode } from '@digiwedge/idp-client';
import { storage } from './storage.js';
export const createAuthSlice = (set) => ({
    isAuthenticated: false,
    token: null,
    refreshToken: null,
    jti: null,
    login: (accessToken, refreshToken, jti, remember = false) => {
        const cookieOnly = getTokenDeliveryMode() === 'cookie';
        if (cookieOnly) {
            storage.removeItem('accessToken');
            storage.removeItem('refreshToken');
            storage.removeItem('jti');
        }
        else {
            // Async write to storage
            storage.setItem('accessToken', accessToken, remember);
            if (refreshToken)
                storage.setItem('refreshToken', refreshToken, remember);
            if (jti)
                storage.setItem('jti', jti, remember);
        }
        // Immediately update in-memory store
        set({
            isAuthenticated: true,
            token: accessToken || null,
            refreshToken: refreshToken || null,
            jti: jti || null,
        });
    },
    setAuthenticated: () => {
        if (getTokenDeliveryMode() === 'cookie') {
            storage.removeItem('accessToken');
            storage.removeItem('refreshToken');
            storage.removeItem('jti');
        }
        set({
            isAuthenticated: true,
            token: null,
            refreshToken: null,
            jti: null,
        });
    },
    logout: () => {
        // Async remove
        storage.removeItem('accessToken');
        storage.removeItem('refreshToken');
        storage.removeItem('jti');
        set({
            isAuthenticated: false,
            token: null,
            refreshToken: null,
            jti: null,
        });
    },
});
//# sourceMappingURL=authSlice.js.map